// src/screens/Admin.js
import React, { useState, useEffect } from "react";
import { fetchAttendance } from "../api";
import { useAuth } from "../hooks/useAuth";
import { toast } from "react-toastify";
import CooldownButton from "../components/CooldownButton";

export default function Admin() {
  const { logout } = useAuth();
  const [data, setData] = useState([]);

  // Load data once on mount
  useEffect(() => {
    let isMounted = true;
    async function loadData() {
      try {
        const list = await fetchAttendance();
        if (isMounted) {
          setData(list);
          toast.success("Data loaded");
        }
      } catch {
        toast.error("Failed to load data");
      }
    }
    loadData();
    return () => {
      isMounted = false;
    };
  }, []);

  // Manual refresh with 1min cooldown
  const handleRefresh = async () => {
    try {
      const list = await fetchAttendance();
      setData(list);
      toast.success("Refreshed");
    } catch {
      toast.error("Refresh failed");
    }
  };

  const styles = {
    container: {
      maxWidth: 360,
      margin: "40px auto",
      padding: 20,
      background: "#fff",
      borderRadius: 12,
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      fontFamily: "sans-serif",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 16,
    },
    heading: {
      fontSize: 20,
      color: "#333",
      margin: 0,
    },
    headerButtons: {
      display: "flex",
      alignItems: "center",
    },
    list: {
      maxHeight: 400,
      overflowY: "auto",
      marginTop: 12,
    },
    item: {
      padding: 12,
      borderBottom: "1px solid #eee",
    },
    username: {
      fontWeight: 600,
      color: "#1976d2",
      marginBottom: 4,
    },
    timestamp: {
      fontSize: 14,
      color: "#555",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.heading}>Admin Panel</h2>
        <div style={styles.headerButtons}>
          <CooldownButton
            onClick={handleRefresh}
            title="Refresh"
            disabled={false}
          />
        </div>
      </div>

      <div style={styles.list}>
        {data.length === 0 ? (
          <div style={{ textAlign: "center", color: "#888", padding: 20 }}>
            No records yet
          </div>
        ) : (
          data.map((r, i) => (
            <div key={i} style={styles.item}>
              <div style={styles.username}>{r.username}</div>
              <div style={styles.timestamp}>
                In: {new Date(r.checkIn).toLocaleTimeString()}
              </div>
              <div style={styles.timestamp}>
                Out:{" "}
                {r.checkOut
                  ? new Date(r.checkOut).toLocaleTimeString()
                  : "-"}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
